import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { HOME_CONTENT_MOCK } from '../data/home-content.mock';
import type {
  HomeHeroBannersActivosResponse,
  HomeHeroContent,
} from '../models/home-hero-content.model';
import { mapHeroBannerToContent } from '../utils/home-hero-banner.mapper';

@Injectable({
  providedIn: 'root',
})
export class HomeHeroService {
  private readonly fallbackContent: HomeHeroContent = {
    ...HOME_CONTENT_MOCK.hero,
  };

  constructor(private readonly bancoldexService: BancoldexService) {}

  /** Primer banner `Bienvenido` activo (orden ASC); fallback al mock si falla o no hay textos. */
  loadContent(): Observable<HomeHeroContent> {
    return this.bancoldexService.getArchivosBannerActivos('Bienvenido').pipe(
      map((response: HomeHeroBannersActivosResponse) => {
        const banner = response?.exitoso ? response.banners?.[0] : undefined;
        if (!banner) {
          return this.fallbackContent;
        }
        return mapHeroBannerToContent(banner, this.fallbackContent);
      }),
      catchError(() => of(this.fallbackContent))
    );
  }
}
